import {
    GET_STATE_LOADING,
    GET_MINDSETS,
} from "@/views/mindset/store/types/types.js";

const getters = {
    [GET_STATE_LOADING]: state => state.loading,
    [GET_MINDSETS]: state => state.listMindset,
}

export default getters;